import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { isAsset } from "@/lib/contentful/guards";
import { ProductFlag } from "../ProductFlag";
import { GalleryCounter } from "./GalleryCounter";
import { GalleryThumbnails } from "./GalleryThumbnails";
import { useProductBuilderContext } from "./ProductBuilderContext";
export default function Gallery() {
  const $ = _c(38);
  const {
    product,
    productWrapper
  } = useProductBuilderContext();
  const images = productWrapper.imagesOverride?.length ? productWrapper.imagesOverride : product.images;
  let T0;
  let T1;
  let resolvedImages;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== images || $[1] !== product) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t6;
      if ($[11] !== product) {
        t6 = asset => {
          const rawUrl = asset.fields.file?.url;
          if (!rawUrl) {
            return [];
          }
          const url = rawUrl.startsWith("//") ? `https:${rawUrl}` : rawUrl;
          const alt = asset.fields.description || asset.fields.title || product.title;
          return [{
            url,
            alt
          }];
        };
        $[11] = product;
        $[12] = t6;
      } else {
        t6 = $[12];
      }
      resolvedImages = images.filter(isAsset).flatMap(t6);
      if (resolvedImages.length === 0) {
        t5 = null;
        break bb0;
      }
      t4 = "flex my-6 lg:my-0 flex-col items-center gap-0";
      T1 = Carousel;
      if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
          loop: true
        };
        $[13] = t2;
      } else {
        t2 = $[13];
      }
      t3 = "static w-full";
      t1 = "relative";
      T0 = CarouselContent;
      let t7;
      if ($[14] !== product) {
        t7 = (image, index) => <CarouselItem key={`${image.url}-${index}`}><div className="relative mx-auto aspect-square w-full max-w-[500px] overflow-hidden rounded-md">{index === 0 && <ProductFlag flag={product.plpFlag} className="absolute top-6 left-6 z-1" />}<Image src={image.url} alt={image.alt} fill={true} sizes="(min-width: 1024px) 500px, 100vw" priority={index === 0} className="object-contain" /></div></CarouselItem>;
        $[14] = product;
        $[15] = t7;
      } else {
        t7 = $[15];
      }
      t0 = resolvedImages.map(t7);
    }
    $[0] = images;
    $[1] = product;
    $[2] = T0;
    $[3] = T1;
    $[4] = resolvedImages;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    T0 = $[2];
    T1 = $[3];
    resolvedImages = $[4];
    t0 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[16] !== T0 || $[17] !== t0) {
    t6 = <T0>{t0}</T0>;
    $[16] = T0;
    $[17] = t0;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CarouselPrevious className="left-4" />;
    t8 = <CarouselNext className="right-4" />;
    $[19] = t7;
    $[20] = t8;
  } else {
    t7 = $[19];
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t1 || $[22] !== t6) {
    t9 = <div className={t1}>{t6}{t7}{t8}</div>;
    $[21] = t1;
    $[22] = t6;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== resolvedImages.length) {
    t10 = <GalleryCounter total={resolvedImages.length} />;
    $[24] = resolvedImages.length;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== resolvedImages) {
    t11 = <GalleryThumbnails images={resolvedImages} />;
    $[26] = resolvedImages;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== T1 || $[29] !== t10 || $[30] !== t11 || $[31] !== t2 || $[32] !== t3 || $[33] !== t9) {
    t12 = <T1 opts={t2} className={t3}>{t9}{t10}{t11}</T1>;
    $[28] = T1;
    $[29] = t10;
    $[30] = t11;
    $[31] = t2;
    $[32] = t3;
    $[33] = t9;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t12 || $[36] !== t4) {
    t13 = <div className={t4}>{t12}</div>;
    $[35] = t12;
    $[36] = t4;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
}